"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchJSON;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Helper function for fetching network resource as JSON
function fetchJSON(_x, _x2) {
  return _fetchJSON.apply(this, arguments);
}

function _fetchJSON() {
  _fetchJSON = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, options) {
    var res;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url, _objectSpread(_objectSpread({}, options), {}, {
              headers: _objectSpread(_objectSpread({}, options.headers), {}, {
                accept: 'application/json'
              })
            }));

          case 2:
            res = _context.sent;

            if (res.ok) {
              _context.next = 5;
              break;
            }

            throw new Error("Failed to fetch JSON from server due to ".concat(res.status));

          case 5:
            return _context.abrupt("return", res.json());

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchJSON.apply(this, arguments);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJmZXRjaEpTT04iLCJ1cmwiLCJvcHRpb25zIiwiZmV0Y2giLCJoZWFkZXJzIiwiYWNjZXB0IiwicmVzIiwib2siLCJFcnJvciIsInN0YXR1cyIsImpzb24iXSwic291cmNlUm9vdCI6ImRpcmVjdGxpbmVzcGVlY2g6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvZmV0Y2hKU09OLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8vIEhlbHBlciBmdW5jdGlvbiBmb3IgZmV0Y2hpbmcgbmV0d29yayByZXNvdXJjZSBhcyBKU09OXG5leHBvcnQgZGVmYXVsdCBhc3luYyBmdW5jdGlvbiBmZXRjaEpTT04odXJsLCBvcHRpb25zKSB7XG4gIGNvbnN0IHJlcyA9IGF3YWl0IGZldGNoKHVybCwge1xuICAgIC4uLm9wdGlvbnMsXG4gICAgaGVhZGVyczoge1xuICAgICAgLi4ub3B0aW9ucy5oZWFkZXJzLFxuICAgICAgYWNjZXB0OiAnYXBwbGljYXRpb24vanNvbidcbiAgICB9XG4gIH0pO1xuXG4gIGlmICghcmVzLm9rKSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKGBGYWlsZWQgdG8gZmV0Y2ggSlNPTiBmcm9tIHNlcnZlciBkdWUgdG8gJHtyZXMuc3RhdHVzfWApO1xuICB9XG5cbiAgcmV0dXJuIHJlcy5qc29uKCk7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTtTQUM4QkEsUzs7Ozs7dUZBQWYsaUJBQXlCQyxHQUF6QixFQUE4QkMsT0FBOUI7SUFBQTtJQUFBO01BQUE7UUFBQTtVQUFBO1lBQUE7WUFBQSxPQUNLQyxLQUFLLENBQUNGLEdBQUQsa0NBQ2xCQyxPQURrQjtjQUVyQkUsT0FBTyxrQ0FDRkYsT0FBTyxDQUFDRSxPQUROO2dCQUVMQyxNQUFNLEVBQUU7Y0FGSDtZQUZjLEdBRFY7O1VBQUE7WUFDUEMsR0FETzs7WUFBQSxJQVNSQSxHQUFHLENBQUNDLEVBVEk7Y0FBQTtjQUFBO1lBQUE7O1lBQUEsTUFVTCxJQUFJQyxLQUFKLG1EQUFxREYsR0FBRyxDQUFDRyxNQUF6RCxFQVZLOztVQUFBO1lBQUEsaUNBYU5ILEdBQUcsQ0FBQ0ksSUFBSixFQWJNOztVQUFBO1VBQUE7WUFBQTtRQUFBO01BQUE7SUFBQTtFQUFBLEMifQ==